import { createRouter, createWebHistory } from 'vue-router'
import StartScreen from '../views/StartScreen.vue'
import PlayerSetup from '../views/PlayerSetup.vue'
import GameScreen from '../views/GameScreen.vue'

const routes = [
  {
    path: '/',
    name: 'Start',
    component: StartScreen
  },
  {
    path: '/player-setup',
    name: 'PlayerSetup',
    component: PlayerSetup
  },
  {
    path: '/game',
    name: 'Game',
    component: GameScreen
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router